import { memo } from "react"
import { useSelector } from "react-redux"
import OrderTable from "./OrderTable"
import Sip from "./Sip"

const objOrderTypes = {
    order: 'orders',
    sipInstructions: "sip_instructions"
}

const OrderDetails = ({ data: { details: fundDetails, orderHistory, }, ...props }) => {
    const { activeOrderType } = useSelector(state => state.mutualFund)

    return (
        activeOrderType?.tabKey === objOrderTypes.order ?
            <OrderTable fundDetails={fundDetails} />
            :
            <Sip orderHistory={orderHistory} fundDetails={fundDetails} />

    )
}
export default memo(OrderDetails)